import React, { useState, useEffect } from 'react';
import { Modal, Col, Row, Button } from 'react-bootstrap';
import { createUserWithEmailAndPassword } from '@firebase/auth';
import StartFirebase, { auth } from "../services/firebaseConfig";
import Table from 'react-bootstrap/Table';

const Leaderboard = (props) => {
    const { allUsers, allPicks, allGames, weekNum } = props;
    const [allResults, setAllResults] = useState([]); //array format should be [uid][wins][loses][bonus points][total points]

    const findArrayElementById = (array, value) => {
        return array.find((element) => {
            return element.key === value;
        })
    }

    useEffect(() => { calculateResults(); }, [allPicks, allGames, allUsers])

    const calculateResults = () => {
        if (allGames.length > 0 && allPicks.length > 0 && allUsers.length > 0) {
            var tempResultList = [];

            try {
                allPicks.map(function (pickDoc, index) {      
                    if (pickDoc.data.week[weekNum] !== undefined) {
                        var totalPoints = 0;
                        var bonusPoints = 0;
                        var totalWins = 0;
                        var totalLoses = 0;
                        var tempPicks = pickDoc;
                        //console.log(tempPicks);     
                        Object.keys(pickDoc.data.week[weekNum]).map(key => {
                            var wins = 0;
                            var loses = 0;
                            var points = 0;
                            var bonus = 0;
                            var AwayScore = +allGames.find(game => game.key === key).data.awayScore;
                            var HomeScore = +allGames.find(game => game.key === key).data.homeScore;
                            var UsersOUPick = +pickDoc.data.week[weekNum][key].ou;
                            var UsersSpreadPick = +pickDoc.data.week[weekNum][key].pick;
                            var Confidence = +pickDoc.data.week[weekNum][key].confidence;
                            var Favorite = +allGames.find(game => game.key === key).data.favorite;
                            var Spread = +allGames.find(game => game.key === key).data.spread;
                            var GameOU = +allGames.find(game => game.key === key).data.overUnder;
                            var SpreadResults = 0;
                            var OUSResults = AwayScore + HomeScore;
                            if (!isNaN(AwayScore) && !isNaN(HomeScore) && (AwayScore > 0 || HomeScore > 0)) {
                                //Favorite 0 = visitor, 1 = home
                                if (Favorite === 0) {
                                    SpreadResults = AwayScore - HomeScore
                                    if (UsersSpreadPick === 0 && SpreadResults >= Spread) {
                                        wins = wins + 1;
                                        points = points + Confidence;
                                    }
                                    else if (UsersSpreadPick === 1 && SpreadResults < Spread) {
                                        wins = wins + 1;
                                        points = points + Confidence;
                                    }
                                    else {
                                        loses = loses + 1;
                                    }
                                }
                                else if (Favorite === 1) {
                                    SpreadResults = HomeScore - AwayScore
                                    if (UsersSpreadPick === 1 && SpreadResults >= Spread) {
                                        wins = wins + 1;
                                        points = points + Confidence;
                                    }
                                    else if (UsersSpreadPick === 0 && SpreadResults < Spread) {
                                        wins = wins + 1;
                                        points = points + Confidence;
                                    }
                                    else {
                                        loses = loses + 1;
                                    }
                                }

                                if (OUSResults !== GameOU) {
                                    if (UsersOUPick === 0) {
                                        if (OUSResults > GameOU) {
                                            wins = wins + 1;
                                            points = points + Confidence;
                                        }
                                        else {
                                            loses = loses + 1;
                                        }
                                    }                                
                                    else if (UsersOUPick === 1) {
                                        if (OUSResults < GameOU) {
                                            wins = wins + 1;
                                            points = points + Confidence;
                                        }
                                        else {
                                            loses = loses + 1;
                                        }
                                    }
                                }
                                else {
                                    loses = loses + 1;
                                }

                                if (wins === 2) {
                                    bonus = bonus + Confidence;
                                }

                                totalPoints = totalPoints + points;
                                totalLoses = totalLoses + loses;
                                totalWins = totalWins + wins;
                                bonusPoints = bonusPoints + bonus;
                            }
                        })
                        tempResultList.push({ "key": pickDoc.key, "wins": totalWins, "loses" : totalLoses, "bonus": bonusPoints, "points" : totalPoints});
                    }
                })
                tempResultList.sort((a,b) => b.points - a.points)
                setAllResults(tempResultList);
            } catch (error) {
                console.log(error);
            }
        }

    }

    return (
        <>            
            <br/>
            <Table striped bordered hover variant="dark" size="sm">
                <tbody>
                    <tr key="header">
                        <th>Name</th>
                        <th>Wins</th>
                        <th>Loses</th>
                        <th>Bonus Points</th>
                        <th>Total Points</th>
                    </tr>
            {                
                allResults.map(function (doc, index) {

                    if (doc.key != null) {
                        var userName = allUsers.find(user => user.key === doc.key)
                    }
                    if (userName !== undefined) {
                        return (
                            <tr key={index}>
                                <td width="40%">{userName.data.name}</td>
                                <td>{doc.wins}</td>
                                <td>{doc.loses }</td>
                                <td>{doc.bonus}</td>
                                <td>{doc.points}</td>
                                </tr>
                        )
                    }
                })}
                </tbody>
            </Table>
        </>
    );
} 

export default Leaderboard;